import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import Universal from '../../views/auth/layout'
import DeleteAccount from '../../views/auth/deleteAccount/form/deleteAccountForm.vue'
import Singpass from "../../views/auth/Singpass/singpass-callback.vue"
import SingPassURL from "../../views/auth/Singpass/redirect-url.vue"
export const constantRouterMap = [
	{ 
		path: '/', 
		component: Universal,
		hidden: true,
		children: [{
			path: '',
			component: () => import('@/views/auth/login')
		}]
	},
	{ 
		path: '/forget-password', 
		component: Universal,
		hidden: true,
		children: [{
			path: '',
			component: () => import('@/views/auth/forgetPassword')
		}]
	},
	{ 
		path: '/delete-account', 
		component: Universal,
		hidden: true,
		children: [{
			path: '',
			component: DeleteAccount
		}]
	},
	{ 
		path: '/singpass-qr-code?amit="dhdgsad"', 
		component: Universal,
		hidden: true,
		children: [{
			path: '',
			component: () => import('@/views/auth/Singpass')
		}]
	},
	{ 
		path: '/singpass-callback', 
		component: Singpass,
		hidden: true,
		children: [{
			path: '',
			component:SingPassURL
		}]			
	},

	{ 
		path: '/something-went-wrong', 
		component: Universal,
		hidden: true,
		children: [{
			path: '',
			component: () => import('@/views/auth/SomethingWentWrong')
		}]
	},
	{ 
		path: '/reset-password', 
		component: Universal,
		hidden: true,
		children: [{
			path: '',
			component: () => import('@/views/auth/resetPassword')
		}]
	},
	{ 
		path: '/token-verify', 
		component: Universal,
		hidden: true,
		children: [
			{
				path: '',
				component: () => import('@/views/auth/verifyData')
			},
			{ 
				path: 'success', 
				component: () => import('@/views/auth/AfterEmailVerify'),
				hidden: true
			}
		]
	},
	{ 
		path: '/device-identity', 
		component: () => import('@/views/auth/DeviceIdentity'),
		hidden: true
	},
	
	{ 
		path: '/register-event-manager/:email', 
		component: Universal,
		hidden: true,
		children: [{
			path: '',
			component: () => import('@/views/auth/registerManager'),
		}]
		
	},
	{ path: '*', hidden: true, component: () => import('@/views/404') }
]

export default new Router({
	mode: 'history', 
	scrollBehavior: () => ({ y: 0 }),
	base: process.env.VUE_APP_DOMAIN_PREFIX,
	routes: constantRouterMap
})